import { Injectable } from '@angular/core';
import { Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { TenantExecutionStatus } from 'src/app/common/enums/statuses';

@Injectable({ providedIn: 'root' })
export class TenantValidator extends Validators {

    constructor() {
        super();        
    }

    static tenantNameExists(control: AbstractControl, tenants: Array<any>) {
        if (control.value == null) {
            return null;
        }

        return tenants.find(x => x.tenantName == control.value.trim() && x.tenantStatusId != 0) ? { 'tenantnameexists': true } : null;
    }
    
    static noWhitespaceValidator(control: AbstractControl) {
        if(control.value == null) {
            return null;
        }
        
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }
}